import { useCallback } from 'react'
import { useMutation } from '@apollo/react-hooks'
import { useHistory } from 'react-router-dom'

import RECORD_IN_APP_MESSAGE_EVENT_MUTATION from '../../../../graphql/mutations/record-in-app-message-event.gql'
import { useMarkMessageRead } from './use-mark-message-read'

export const canSelectMessageCta = message => Boolean(
  message.ctaText &&
  message.ctaAction === 'VIEW_CONTENT' &&
  message.contentPath
)

/**
 * Returns a CTA handler for an in-app message: marks the message read (only
 * when still UNREAD, see useMarkMessageRead), records the CTA_SELECTED event
 * and navigates to the promoted content.
 */
export const useSelectMessageCta = () => {
  const history = useHistory()
  const markMessageRead = useMarkMessageRead()
  const [recordInAppMessageEvent] = useMutation(
    RECORD_IN_APP_MESSAGE_EVENT_MUTATION
  )

  return useCallback(message => {
    if (!canSelectMessageCta(message)) return

    // Fire-and-forget: a failed read-state or analytics call must not block navigation
    markMessageRead(message)?.catch(() => null)
    recordInAppMessageEvent({
      variables: {
        input: { messageId: message.id, eventType: 'CTA_SELECTED' }
      }
    }).catch(() => null)
    history.push(message.contentPath)
  }, [history, markMessageRead, recordInAppMessageEvent])
}
